export default __webpack_public_path__ + "static/media/arrow.57eff30f.svg";